import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TenantUser, TenantUserList } from '../../_objects/user';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root'
})
export class TenantUserOnlineService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }
  // TN01 GET /api/v1/users
  getUsers(): Observable<TenantUserList[]> {
    const endpoint = super.getEndpoint('users');

      return this.http.get<TenantUserList[]>(endpoint,
        { withCredentials: super.getWithCredentialsOption() })
        .pipe(map(response => response as TenantUserList[]));
  }
  // TN02 GET /api/v1/users/{userId}
  getUser(id: string): Observable<TenantUser> {
    const endpoint = super.getEndpoint('users', id);

      return this.http.get<TenantUser>(endpoint, { withCredentials: super.getWithCredentialsOption() })
        .pipe(map(response => response as TenantUser));
  }
}
